import axiosInstance from 'helpers/axiosInstance';

import { Patient } from './patients.type';

interface PatientsResponse {
  patient: Patient;
}

export const getPatientById = async (
  patientId: string | string[] | undefined,
) => {
  const url = `/patients/patients/${patientId}`;

  return axiosInstance.get<PatientsResponse>(url).then(r => r.data.patient);
};
